
import * as css from './css';
import { ClientApiModule } from './module';

let _module: ClientApiModule;

export interface InitOptionsType {
    target: string
    product_sample_link?: string[]
    debug?: boolean
    onsubmit?: (data: { id: string, area: number, products: string[] }) => void
}

export async function init(options: InitOptionsType) {
    css.load();
    _module = new ClientApiModule();
    _module.init(options);
}

export function refresh() {
    _module.refresh();
}

export function reset() {
    _module.reset();
}

